import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Indicators } from 'ui'
import { useAuthStatus } from './useAuthStatus'

export const SessionRedirect: React.FC = () => {
  const history = useHistory()
  const { admin, authenticated } = useAuthStatus()
  useEffect(() => {
    if (admin) {
      history.replace('/admin')
      return
    }
    history.replace(authenticated ? '/app/dashboard' : '/login')
  }, [admin, authenticated, history])
  return <Indicators.Spinner size="lg" />
}
